import { DataResult, State, toDataSourceRequestString } from "@progress/kendo-data-query";
import { Grid, GridColumn, GridDataStateChangeEvent } from "@progress/kendo-react-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SweetAlertService from "../../../services/SweetAlertService";
import { ColumnMenuDefaultFilter } from "../Shared/Components/ColumnMenuFilter";
import PublicHolidayService from "../Shared/Services/PublicHolidayService";

export const PublicHolidayList = () => {
    let initialState = { dataState: { skip: 0, take: 10 }, result: { data: [], total: 0 } };
    const [result, setResult] = useState<DataResult>(initialState.result);
    const [dataState, setDataState] = useState<State>(initialState.dataState);

    useEffect(() => {
        fetchData(dataState);
    }, []);

    const fetchData = (state: State) => {
        const queryStr = `${toDataSourceRequestString(state)}`; // Serialize the state
        PublicHolidayService.getAll(queryStr)
            .then((response) => {
                response.data.data.map((e: any) => (
                    e.date = new Date(e.date)
                ));
                setResult({ data: response.data.data, total: response.data.total });
                setDataState(state);
            });
    }

    const dataStateChange = (event: GridDataStateChangeEvent) => {
        setDataState(event.dataState);
        fetchData(event.dataState);
    };

    const navigate = useNavigate();

    const renderActionCell = (props: any) => {
        return (
            <td>
                <a className="btn btn-primary btn-sm" onClick={() => navigate(`/viewpublicholiday/${props.dataItem.id}`)}>
                    <span className="k-icon k-i-information k-icon-color"></span>
                </a>&nbsp;
                <a className="btn btn-primary btn-sm" onClick={() => deletePublicHoliday(`${props.dataItem.id}`)}>
                    <span className="k-icon k-i-delete k-icon-color"></span>
                </a>
            </td>
        );
    };

    const deletePublicHoliday = async (id: any) => {
        const tittle = 'Delete';
        const message = 'Are you sure you want to delete this?';
        const response = await SweetAlertService.confirm(tittle, message);
        if (response.isConfirmed) {
            PublicHolidayService.deleteById(id).then((res) => {
                if (res) {
                    fetchData(dataState);
                } 
            })
        }
    }

    const updatePublicHolidays = async () => {
        const response = await SweetAlertService.confirm("Update public holidays", "This will update the list of public holidays in GP Diary with those published on the gov.uk website. Do you wish to proceed?");
        if (response.isConfirmed) {
            PublicHolidayService.updatePublicHolidaysFromAPI()
                .then((response) => {
                    if (response) {
                        fetchData(dataState);
                        SweetAlertService.success("Success", "Public holidays refreshed successfully");
                    } else {
                        SweetAlertService.error("Error", "Error while refreshing the public holidays");
                    }
                });
        }
    }

    return (
        <div className="card card-default">
            <div className="card-header">
                <h4>Public Holidays
                    <button
                        title="Refresh"
                        className="btn btn-primary pull-right"
                        onClick={() => updatePublicHolidays()}>
                        Update public holidays
                    </button>
                    <button hidden
                        title="Add new"
                        className="btn btn-primary pull-right"
                        onClick={() => navigate('/addpublicholiday')}>
                        Add new
                    </button>
                </h4>
            </div>
            <div className="card-body card-body-custom">
                <Grid
                    sortable={true}
                    pageable={{
                        buttonCount: 4,
                        pageSizes: [5, 10, 15, 20],
                    }}
                    {...dataState}
                    data={result}
                    onDataStateChange={dataStateChange}>

                    <GridColumn field="name" title="Name" columnMenu={ColumnMenuDefaultFilter} width="315px"/>
                    <GridColumn field="date" filter="date" format="{0:dd/MM/yyyy}" title="Date" columnMenu={ColumnMenuDefaultFilter} width="315px" />
                    {/*<GridColumn field="holidaySource" filter="numeric" title="HolidaySource" columnMenu={ColumnMenuDefaultFilter} />*/}
                    <GridColumn field="countryName" title="Country" columnMenu={ColumnMenuDefaultFilter} width="315px" />
                    <GridColumn title="Action" cell={renderActionCell} width="295px" />
                </Grid>
            </div>
        </div>
    )
}